import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { SettingsIcon, LogOutIcon, ChevronDownIcon } from 'lucide-react';
export function UserProfile() {
  const {
    user,
    logout
  } = useAuth();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);
  if (!user) return null;
  const initials = user.name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);
  const handleLogout = () => {
    logout();
    setIsOpen(false);
  };
  return <div className="relative" ref={dropdownRef} data-id="element-130">
      {/* Profile Button */}
      <button onClick={() => setIsOpen(!isOpen)} className="flex items-center gap-2 px-3 py-1.5 rounded-md hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors" data-id="element-131">
        {/* Avatar */}
        <div className="w-8 h-8 rounded-full bg-blue-600 dark:bg-blue-500 flex items-center justify-center" data-id="element-132">
          <span className="text-xs font-semibold text-white" data-id="element-133">{initials}</span>
        </div>

        {/* Name */}
        <span className="text-sm font-medium text-slate-900 dark:text-slate-100 hidden sm:block" data-id="element-134">
          {user.name}
        </span>

        {/* Chevron */}
        <ChevronDownIcon className={`h-4 w-4 text-slate-500 dark:text-slate-400 transition-transform ${isOpen ? 'rotate-180' : ''}`} data-id="element-135" />
      </button>

      {/* Dropdown Menu */}
      {isOpen && <div className="absolute right-0 mt-2 w-64 bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-md shadow-lg py-2 z-50" data-id="element-136">
          {/* User Info */}
          <div className="px-4 py-3 border-b border-slate-100 dark:border-slate-800" data-id="element-137">
            <p className="text-sm font-medium text-slate-900 dark:text-slate-100" data-id="element-138">
              {user.name}
            </p>
            <p className="text-xs text-slate-500 dark:text-slate-400 mt-0.5" data-id="element-139">
              {user.email}
            </p>
          </div>

          {/* Menu Items */}
          <div className="py-1" data-id="element-140">
            <Link to="/settings" onClick={() => setIsOpen(false)} className="flex items-center gap-3 px-4 py-2 text-sm text-slate-700 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors" data-id="element-141">
              <SettingsIcon className="h-4 w-4" data-id="element-142" />
              Account Settings
            </Link>

            <button onClick={handleLogout} className="w-full flex items-center gap-3 px-4 py-2 text-sm text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/20 transition-colors" data-id="element-143">
              <LogOutIcon className="h-4 w-4" data-id="element-144" />
              Sign Out
            </button>
          </div>
        </div>}
    </div>;
}